//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'

export default {
  name: 'DateTimeField',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: undefined
    },
    dense: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: undefined
    },
    noYear: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      ignoreNextFieldClickEvent: false
    }
  },
  computed: {
    textValue: {
      get: function () {
        return this.value != null ? this.formatMillis(this.value) : null
      },
      set: function (textValue) {
        this.$emit('input', textValue ? this.parseMillis(textValue) : null)
      }
    },
    empty: function () {
      return this.value == null
    },
    formatDate: function () {
      if (this.noYear) {
        return 'DD.MM'
      } else {
        return 'DD.MM.YYYY'
      }
    }
  },
  methods: {
    formatMillis: function (millis) {
      if (millis) {
        return date.formatDate(millis, this.formatDate)
      }
      return null
    },
    parseDate (value) {
      return date.extractDate(value, this.formatDate)
    },
    parseMillis (value) {
      let millis = this.parseDate(value).getTime()

      // Если год не отображается, для сервера нужно скорректировать миллисекунды (как будто год есть)
      if (this.noYear) {
        const currentYear = new Date().getFullYear()
        millis = new Date(millis).setFullYear(currentYear)
      }
      return millis
    },

    onFieldClick: function () {
      if (this.ignoreNextFieldClickEvent) {
        this.ignoreNextFieldClickEvent = false
        return
      }
      if (!this.readonly) {
        this.$refs.datePicker.show()
      }
    },
    onInput: function (textValue) {
      this.textValue = textValue
      this.$refs.datePicker.hide()
    },
    onClear: function () {
      this.textValue = null
      this.ignoreNextFieldClickEvent = true
    },

    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
